import { render, staticRenderFns } from "./CalendarPage.vue?vue&type=template&id=6d989a90"
import script from "./CalendarPage.vue?vue&type=script&lang=js"
export * from "./CalendarPage.vue?vue&type=script&lang=js"
import style0 from "./CalendarPage.vue?vue&type=style&index=0&id=6d989a90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports